export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ05.0d3353ec.mp3";